import { render, staticRenderFns } from "./UomList.vue?vue&type=template&id=04d9266c"
import script from "./UomList.vue?vue&type=script&lang=js"
export * from "./UomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports